import React, { useState ,useEffect } from "react";
import axios from "axios";
import "./Bootcamp.css";

const Bootcamp = () => {
 useEffect(() => {
   const navbar = document.querySelector("header, .navbar");
   const footer = document.querySelector("footer");
 
  
   if (navbar) navbar.style.display = "none";
   if (footer) footer.style.display = "none";
 
   return () => {
     // 🔥 மீண்டும் restore
     if (navbar) navbar.style.display = "";
     if (footer) footer.style.display = "";
   };
 }, []);
  // ===============================
  // FORM STATE
  // ===============================

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    sport: ""
  });

  const [loading, setLoading] = useState(false);

  // ===============================
  // HANDLE CHANGE
  // ===============================

  const handleChange = (e) => {

    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });

  };

  // ===============================
  // HANDLE SUBMIT
  // ===============================

 const [message, setMessage] = useState("");
const [messageType, setMessageType] = useState("");

const handleSubmit = async () => {

  // ==========================================
  // PREVENT DOUBLE CLICK
  // ==========================================

  if (loading) return;

  // ==========================================
  // VALIDATION
  // ==========================================

  if (
    !formData.name ||
    !formData.email ||
    !formData.phone ||
    !formData.sport
  ) {

    setMessage("Please fill all fields");
    setMessageType("error");

    return;
  }

  try {

    setLoading(true);

    setMessage("");

    const response = await axios.post(
      "/api/bootcamp-register",
      {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        sport: formData.sport
      }
    );

    // SUCCESS

    setMessage(response.data.message);
    setMessageType("success");

    // RESET FORM

    setFormData({
      name: "",
      email: "",
      phone: "",
      sport: ""
    });

  } catch (error) {

    console.log(error);

    if (error.response?.data?.error) {

      setMessage(error.response.data.error);

    } else {

      setMessage("Something went wrong");

    }

    setMessageType("error");

  } finally {

    setLoading(false);

  }

};
  return (
   <div className="forge-page">

  {/* =========================
      NAVBAR
  ========================= */}

  <header className="forge-navbar">

    <a
      href="https://forgeyourpeak.in"
      target="_blank"
      rel="noopener noreferrer"
      className="forge-logo-link"
    >
      <img
        src="/Logo.png"
        alt="Forge Your Peak"
        className="brand-logo"
      />

      <span className="forge-logo-text">
        FORGE YOUR PEAK
      </span>
    </a>
    <div className="forge-nav-right">
      <a href="#why">WHY</a>

      <button
        className="forge-nav-btn"
        onClick={() => {
          document
            .querySelector(".forge-form-card")
            .scrollIntoView({
              behavior: "smooth"
            });
        }}
      >
        REGISTER FREE
      </button>
    </div>

  </header>

      {/* =========================
          HERO SECTION
      ========================= */}

      <section className="forge-hero">

        {/* LEFT */}
        <div className="forge-left">

          <h1 className="forge-title">
            TRAIN
            <br />
            YOUR
            <br />
            <span>VISION.</span>
            <br />
            WIN MORE.
          </h1>

          <p className="forge-description">
            The <strong>₹499 Vision & Cognitive Performance Bootcamp</strong>
            {" "}— free for 100 athletes who register before May 24.
            6 focused days. Online. Built for serious athletes only.
          </p>

          <div className="forge-stats">

            <div className="stat-box">
              <h2>100</h2>
              <p>FREE SPOTS</p>
            </div>

            <div className="stat-box">
              <h2>6</h2>
              <p>DAYS LIVE</p>
            </div>

            <div className="stat-box">
              <h2>₹0</h2>
              <p>COST</p>
            </div>

          </div>

          <button className="forge-main-btn"
           onClick={() => {
    document
      .querySelector(".forge-form-card")
      .scrollIntoView({
        behavior: "smooth"
      });
  }}
>
            CLAIM YOUR FREE SPOT →
          </button>

        </div>

        {/* RIGHT FORM */}

        <div className="forge-form-card">

          <p className="form-small">
            FREE ACCESS — 100 ATHLETES ONLY
          </p>

          <h2>
            REGISTER FOR THE
            <br />
            FREE BOOTCAMP
          </h2>

          <p className="form-text">
            Normally ₹499 — completely free
            for the first 100 athletes.
          </p>

          <div className="badge">
            FREE • MAY 25-30 • ONLINE
          </div>

          {/* NAME */}

          <input
            type="text"
            name="name"
            placeholder="Full Name *"
            value={formData.name}
            onChange={handleChange}
          />

          {/* EMAIL */}

          <input
            type="email"
            name="email"
            placeholder="Email Address *"
            value={formData.email}
            onChange={handleChange}
          />

          {/* PHONE */}

          <input
            type="text"
            name="phone"
            placeholder="WhatsApp Number *"
            value={formData.phone}
            onChange={handleChange}
          />

          {/* SPORT */}

          <select
            name="sport"
            value={formData.sport}
            onChange={handleChange}
          >

            <option value="">
              Your Sport *
            </option>

            <option value="Football">
              Football
            </option>

            <option value="Cricket">
              Cricket
            </option>

            <option value="Basketball">
              Basketball
            </option>

            <option value="Tennis">
              Tennis
            </option>
            <option value="others">
              Other
            </option>

          </select>

          {/* SUBMIT BUTTON */}

          <button
            className="forge-submit-btn"
            onClick={handleSubmit}
            disabled={loading}
          >

            {
              loading
                ? "REGISTERING..."
                : "CLAIM MY FREE SPOT →"
            }

          </button>
          {
  message && (
    <p
      style={{
        marginTop: "15px",
        color:
          messageType === "Register successfully"
            ? "#00c853"
            : "#ff1744",
        fontWeight: "bold",
        textAlign: "center"
      }}
    >
      {message}
    </p>
  )
}

          <p className="note">
            No payment. No credit card.
            Access details sent via email.
          </p>

          <div className="spots">

          

            <div className="progress">
              <div className="progress-fill"></div>
            </div>

          </div>

        </div>

      </section>

      {/* =========================
          STRIP
      ========================= */}

      <section className="forge-strip">

        <span>PERIPHERAL AWARENESS</span>
        <span>•</span>

        <span>DECISION MAKING</span>
        <span>•</span>

        <span>FOCUS UNDER PRESSURE</span>
        <span>•</span>

        <span>MENTAL ENDURANCE</span>
        <span>•</span>

        <span>ELITE PERFORMANCE</span>
        <span>•</span>

        <span>VISION TRAINING</span>

      </section>

      {/* =========================
          PROBLEM SECTION
      ========================= */}

      <section className="problem-section" id="why">

        <p className="problem-label">
          — THE PROBLEM
        </p>

        <h2 className="problem-title">
          YOU'RE TRAINING
          <br />
          THE <span>WRONG THING.</span>
        </h2>

        <p className="problem-desc">
          90% of athletes invest everything in their body.
          Almost none train the skill that separates
          good from elite — cognitive performance.
        </p>

        <div className="problem-grid">

          <div className="problem-card">

            <div className="problem-number">
              01
            </div>

            <h3>
              HALF A SECOND LATE
            </h3>

            <p>
              You see the moment after it happens —
              the pass, the gap, the opening.
              It's cognitive processing speed,
              and it's trainable.
            </p>

          </div>

          <div className="problem-card">

            <div className="problem-number">
              02
            </div>

            <h3>
              FREEZE UNDER PRESSURE
            </h3>

            <p>
              Big moments. High stakes.
              Your body is ready but your brain locks up.
              That's attentional narrowing.
            </p>

          </div>

          <div className="problem-card">

            <div className="problem-number">
              03
            </div>

            <h3>
              MISSING THE FULL PICTURE
            </h3>

            <p>
              Most athletes focus straight ahead
              and miss everything else.
              Peripheral awareness is a trained skill.
            </p>

          </div>

        </div>

      </section>

      {/* =========================
          BRAIN SECTION
      ========================= */}

      <section className="brain-section">

        {/* LEFT */}

        <div className="brain-left">

          <div className="improve-card">

            <p className="mini-label">
              PERFORMANCE IMPROVEMENTS AFTER TRAINING
            </p>

            <div className="improve-item">

              <div className="improve-top">
                <span>REACTION SPEED</span>
                <h3>+34%</h3>
              </div>

              <div className="line">
                <div className="fill fill-1"></div>
              </div>

            </div>

            <div className="improve-item">

              <div className="improve-top">
                <span>PERIPHERAL AWARENESS</span>
                <h3>+28%</h3>
              </div>

              <div className="line">
                <div className="fill fill-2"></div>
              </div>

            </div>

            <div className="improve-item">

              <div className="improve-top">
                <span>DECISION SPEED</span>
                <h3>+41%</h3>
              </div>

              <div className="line">
                <div className="fill fill-3"></div>
              </div>

            </div>

            <div className="improve-item">

              <div className="improve-top">
                <span>FOCUS UNDER PRESSURE</span>
                <h3>+22%</h3>
              </div>

              <div className="line">
                <div className="fill fill-4"></div>
              </div>

            </div>

            <p className="small-note">
              Average improvements reported across structured
              cognitive performance training programmes.
            </p>

          </div>

        </div>

        {/* RIGHT */}

        <div className="brain-right">

          <p className="brain-label">
            — WHAT IS THIS?
          </p>

          <h2 className="brain-title">
            YOUR BRAIN
            <br />
            IS YOUR MOST
            <br />
            <span>POWERFUL</span>
            <br />
            WEAPON.
          </h2>

          <p className="brain-text">
            Vision training is not eyesight training.
            It means <strong>how fast your brain processes
            what your eyes see.</strong>
          </p>

          <p className="brain-text">
            Cognitive training means training your attention,
            decision-making, and focus under pressure.
          </p>

          <div className="brain-list">

            <div className="brain-row">
              <span>01</span>
              <p>
                Anticipatory cognition — reading the play before it unfolds
              </p>
            </div>

            <div className="brain-row">
              <span>02</span>
              <p>
                Visual tracking — sharper, faster movement processing
              </p>
            </div>

            <div className="brain-row">
              <span>03</span>
              <p>
                Attentional control — awareness under pressure
              </p>
            </div>

            <div className="brain-row">
              <span>04</span>
              <p>
                Cognitive endurance — peak performance for longer
              </p>
            </div>

            <div className="brain-row">
              <span>05</span>
              <p>
                Decision speed — the right call faster than anyone else
              </p>
            </div>

          </div>

        </div>

      </section>

      {/* =========================
          NOT FOR EVERYONE
      ========================= */}

      <section className="not-section">

        <div className="not-header">

          <p>
            — IS THIS FOR YOU?
          </p>

          <h2>
            NOT FOR
            <br />
            <span>EVERYONE.</span>
          </h2>

        </div>

        <div className="not-grid">

          {/* LEFT */}

          <div className="not-box">

            <h3>
              ✓ THIS IS FOR YOU IF...
            </h3>

            <div className="not-item">
              ✓ You train hard and want to find your hidden edge
            </div>

            <div className="not-item">
              ✓ You've felt half a second too slow in the key moment
            </div>

            <div className="not-item">
              ✓ You study your sport — not just play it
            </div>

            <div className="not-item">
              ✓ You want to train something nobody else is training
            </div>

            <div className="not-item">
              ✓ You're serious about long-term athletic development
            </div>

            <div className="not-item">
              ✓ You want a measurable performance system
            </div>

          </div>

          {/* RIGHT */}

          <div className="not-box faded">

            <h3>
              ✕ THIS IS NOT FOR YOU IF...
            </h3>

            <div className="not-item">
              ✕ You're looking for a gym or fitness programme
            </div>

            <div className="not-item">
              ✕ You want quick shortcuts without effort
            </div>

            <div className="not-item">
              ✕ You're happy where your performance is now
            </div>

            <div className="not-item">
              ✕ You won't commit to 6 days of focused training
            </div>

            <div className="not-item">
              ✕ You think mental performance is irrelevant
            </div>

            <div className="not-item">
              ✕ You're a casual exerciser
            </div>

          </div>

        </div>

      </section>

      {/* =========================
          LIMITED ACCESS
      ========================= */}

      <section className="limited-section">

        <div className="limited-content">

          <p className="limited-label">
            — LIMITED ACCESS
          </p>

          <h2 className="limited-title">
            100 ATHLETES.
            <br />
            <span>THAT'S ALL.</span>
          </h2>

          <p className="limited-text">
            This bootcamp is capped at 100 athletes —
            because we want every person to get real value,
            real attention, and real results.
          </p>

          <div className="limited-stats">

            

            <div className="limited-box">
              <h3>
                MAY
                <br />
                24
              </h3>
              <span>CLOSES</span>
            </div>

            <div className="limited-box">
              <h3>₹0</h3>
              <span>COST</span>
            </div>

          </div>

          <button className="limited-btn"
           onClick={() => {
                document
                .querySelector(".forge-form-card")
                .scrollIntoView({
                    behavior: "smooth"
                });
            }}
            >

            CLAIM YOUR SPOT NOW →
          </button>

        </div>

        <div className="bg-100">
          100
        </div>

      </section>

      {/* =========================
          FOOTER
      ========================= */}

      <footer className="forge-footer">

        <div className="footer-logo">
          FORGE YOUR PEAK
        </div>

        <div className="footer-copy">
          © 2025 FORGEYOURPEAK.IN • ALL RIGHTS RESERVED
        </div>

      </footer>

    </div>
  );
};

export default Bootcamp;